export enum MachineType {
    LOCKER = 'LOCKER'
}